export function mitZustand<T extends object>(
  basis: T,
  zustaende: Record<string, Partial<T> & { leer?: true }> | undefined,
  zustand: string | undefined,
): T | "leer" {
  const u = zustand === undefined ? undefined : zustaende?.[zustand];
  if (!u) return basis;
  if (u.leer) return "leer";
  const { leer: _, ...rest } = u;
  return { ...basis, ...rest };
}
